/* Málaga: sugerencias mientras se escribe en el buscador.

   Pide /search/suggest y pinta la sección predictive-search, así el markup de los
   resultados vive en Liquid y no duplicado acá.

   Sin JavaScript el buscador sigue siendo un formulario normal que lleva a /search. */

(() => {
  const dialog = document.getElementById('search-dialog');
  if (!dialog) return;

  const input = dialog.querySelector('input[name="q"]');
  const panel = dialog.querySelector('[data-predictive]');
  if (!input || !panel) return;

  const MIN = 2;
  let timer = 0;
  let controller = null;

  const clear = () => {
    panel.replaceChildren();
    panel.classList.remove('is-open');
  };

  const search = async (term) => {
    controller?.abort();
    controller = new AbortController();
    const url = new URL('/search/suggest', location.origin);
    url.searchParams.set('q', term);
    url.searchParams.set('section_id', 'predictive-search');
    url.searchParams.set('resources[type]', 'product,query');
    url.searchParams.set('resources[limit]', '6');

    try {
      const res = await fetch(url, { signal: controller.signal });
      if (!res.ok) throw new Error(res.status);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = doc.querySelector('[data-predictive-fragment]');
      if (!fresh) return clear();
      panel.replaceChildren(...fresh.childNodes);
      panel.classList.toggle('is-open', panel.textContent.trim() !== '');
    } catch (err) {
      if (err.name !== 'AbortError') clear();
    }
  };

  input.addEventListener('input', () => {
    const term = input.value.trim();
    clearTimeout(timer);
    if (term.length < MIN) return clear();
    // Espera a que deje de tipear: sin esto se dispara un pedido por tecla
    timer = setTimeout(() => search(term), 250);
  });

  // Al cerrar el buscador, limpiar
  dialog.addEventListener('close', clear);

  // Escape cierra el panel antes que el diálogo, si hay sugerencias abiertas
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && panel.classList.contains('is-open')) {
      e.stopPropagation();
      clear();
    }
  });
})();
